export default __webpack_public_path__ + "b64f84c.png";